import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Roadmap } from './roadmap';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class RoadmapService {
  private serviceUrl = environment.API_URL + 'roadmap';

  constructor(private _httpClient: HttpClient) { }

  getFrontendVersion(): Observable<any> {
    return this._httpClient.get(this.serviceUrl + '/frontendversion/')
  }

  getVersionList(): Observable<any> {
    return this._httpClient.get(this.serviceUrl + '/versionlist/')
  }

  getRoadmapList(showPlanning: boolean): Observable<any> {
    return this._httpClient.get(this.serviceUrl + '/list/' + showPlanning)
  }

  saveRoadmap(roadmap: Roadmap): Observable<any> {
    if (roadmap.RoadMapId == 0) {
      //add 
      return this._httpClient.post(this.serviceUrl, roadmap)
    } else {
      //edit
      return this._httpClient.put(this.serviceUrl, roadmap)
    }
  }

  deleteRoadmap(roadmapId: number): Observable<any> {
    return this._httpClient.delete(this.serviceUrl + '/?id=' + roadmapId)
  }

}
